import React, { useEffect, useState } from 'react';
import 'App.css';
import Container from 'react-bootstrap/Container';
import InstructionsModal from '../InstructionsModal';
import Row from 'react-bootstrap/Row';
import { Route, Routes, NavLink } from 'react-router-dom';
import UnitCostCategory from './UnitCostCategory';

function UnitCostCombos(props) {

  const setTitle = props.setTitle
  const [showModal, setShowModal] = useState(false);

  const [UnitCostCategories, setUnitCostCategories] = useState([]);

  useEffect(() => {
    fetch('/unit-costs-data/UnitCostCategories.json')
      .then(response => response.json())
      .then(json => setUnitCostCategories(json))
      .catch(error => console.error(error));
  }, []);

  useEffect(() => {
    setTitle("Discover Fun Combos with unit costs.");
  }, [setTitle]);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Container className='unit-costs-apps'>
      <h1 className="calc-header">Unit Cost Combos</h1>
      <InstructionsModal handleCloseModal={handleCloseModal} handleOpenModal={handleOpenModal} showModal={showModal}>
        <p>When you have some money to spend on a category of purchase, it might be interesting to think what else you could buy for that money.</p>
        <p>The example I like to use is $50 could get you 2 movie tickets, and 1 bubble tea and 1 coffee for example.</p>
      </InstructionsModal>
      <Row>
        <ul className="container nav nav-pills" style={{ width: '95%', marginBottom: '1.5em' }}>
          {UnitCostCategories.map((category) => (
            <li key={category.name} className='nav-item'><NavLink className='nav-link' to={category.name} state={{ title: "value" }}>{category.title}</NavLink></li>
          ))}
        </ul>
      </Row>
      <Row>
        <Routes>
          {UnitCostCategories.map((category) => (
            <Route key={category.name} path={category.name} element={<UnitCostCategory setTitle={props.setTitle} dataPath={category.name} title={category.title} />} />
          ))}
        </Routes>
      </Row>
    </Container>
  );
};

export default UnitCostCombos;
